import { useTranslation } from "pro-features/components/WithTranslation";

import { DomainSelect } from "../domain-input/domain-select";

const SEARCH_FIELD_WIDTH = "78%";

const noop = () => undefined;

interface IDomainSearchProps {
    placeholder?: string;
    value?: string;
    onSelect?: (domain: string) => void;
    onSearchBarClick?: () => void;
    onSearchResultClick?: (domain: string) => void;
}

export const DomainSearch = ({
    placeholder,
    value = "",
    onSelect,
    onSearchBarClick,
    onSearchResultClick,
}: IDomainSearchProps) => {
    const translate = useTranslation();

    return (
        <DomainSelect
            value={value}
            onChange={onSelect ?? noop}
            placeholder={placeholder ?? translate("monitor_and_protect.domain_search.placeholder")}
            width={SEARCH_FIELD_WIDTH}
            dataAutomation="mnp-domain-search"
            onOpen={onSearchBarClick}
            onPick={onSearchResultClick}
        />
    );
};
